import React, { useState, useEffect,useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import API_URL from "../config";
import { Box, Grid, Card, CardContent, Typography, Button, ButtonGroup, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

const SessionDetails = () => {
  const { sessionId } = useParams();
  const [session, setSession] = useState(null);
  const canvasRef = useRef(null);
  const [originalCanvasSize, setOriginalCanvasSize] = useState({ width: 800, height: 600 }); 

  const adjustDateToDayOfWeek = (timeString, targetDay, referenceTimeString = null) => {
    const time = new Date(timeString);
    const now = new Date();

    const diff = (targetDay - now.getDay() + 7) % 7;
    let eventDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + diff,
      time.getHours(),
      time.getMinutes(),
      time.getSeconds()
    );

    if (referenceTimeString) {
      const refTime = new Date(referenceTimeString);
      const refMinutes = refTime.getHours() * 60 + refTime.getMinutes();
      const eventMinutes = eventDate.getHours() * 60 + eventDate.getMinutes();
      if (eventMinutes <= refMinutes) {
        eventDate.setDate(eventDate.getDate() + 1);
      }
    }
    return eventDate.toISOString();
  };

  useEffect(() => {
    fetchSessionDetails();
  }, [sessionId]);

  const hasAdjustedPositions = useRef(false);

  useEffect(() => {
    if (!canvasRef.current || !session || !session.pods || session.pods.length === 0 || hasAdjustedPositions.current) return;
  
    hasAdjustedPositions.current = true;
  
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect(); 
    const newCanvasWidth = rect.width;
    const newCanvasHeight = rect.height;
  
    const scaleX = newCanvasWidth / 800;
    const scaleY = newCanvasHeight / 600;
    const scaleFactor = Math.min(scaleX, scaleY);
  
    const centerX = 800 / 2;
    const centerY = 600 / 2;
    const newCenterX = newCanvasWidth / 2;
    const newCenterY = newCanvasHeight / 2;
    console.log(newCenterX, newCenterY);

    const updatedPods = session.pods.map((pod) => {
      const originalX = pod.x ?? Math.random() * 800;
      const originalY = pod.y ?? Math.random() * 600;
  
      const offsetX = originalX - centerX;
      const offsetY = originalY - centerY;
      console.log(offsetX, offsetY,scaleFactor);
  
      const newX = Math.round(newCenterX + offsetX * scaleFactor);
      const newY = Math.round(newCenterY + offsetY * scaleFactor);
  
      console.log(`Pod ${pod.podId}: Original (${originalX}, ${originalY}) → New (${newX}, ${newY})`);
  
      return {
        ...pod,
        x: newX,
        y: newY,
        tableWidth: Math.round(100 * scaleFactor), 
        seatSize: Math.round(30 * scaleFactor) 
      };
    });
  
    setSession(prevSession => ({
      ...prevSession,
      pods: updatedPods
    }));
  
  }, [session?.pods]);
  
  
  const fetchSessionDetails = async () => {
    try {
      console.log("Fetching session details...");
      const response = await axios.get(`${API_URL}/lab-sessions/${sessionId}`);
      
      setSession(prevSession => {
        if (!prevSession) return response.data; 
        return {
          ...prevSession,
          ...response.data, 
          pods: prevSession.pods || response.data.pods 
        };
      });
  
      console.log("Fetched session:", response.data);
    } catch (error) {
      console.error("Error fetching session details:", error);
    }
  };

  const renderPodLayout = (pod) => {
    switch (pod.direction) {
      case "horizontal-left":
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {/* Pod label on the left */}
            <Typography variant="subtitle2" sx={{ mr: 1 }} >
              Pod-{pod.podId}
            </Typography>
            <Box>
              <Box sx={{ display: 'flex' }}>
                <Button
                  variant="text"
                  sx={{
                    backgroundColor: pod.seats[0].status === "Available" ? 'green' : 'red',
                    color: 'white',
                    minWidth: {xs:'auto',md:'30px'},
                    padding: { xs: '2px', md: '8px' }
                  }}
                >
                  {pod.seats[0].seatId}
                </Button>
                <Button
                  variant="text"
                  sx={{
                    backgroundColor: pod.seats[1].status === "Available" ? 'green' : 'red',
                    color: 'white',
                    minWidth: {xs:'auto',md:'30px'},
                    padding: { xs: '2px', md: '8px' }
                  }}
                >
                  {pod.seats[1].seatId}
                </Button>
              </Box>
              <Box sx={{ display: 'flex', mt: {sx:0, md:1} }}>
                <Button
                  variant="text"
                  sx={{
                    backgroundColor: pod.seats[2].status === "Available" ? 'green' : 'red',
                    color: 'white',
                    minWidth: {xs:'auto',md:'30px'},
                    padding: { xs: '2px', md: '8px' }
                  }}
                >
                  {pod.seats[2].seatId}
                </Button>
                <Button
                  variant="text"
                  sx={{
                    backgroundColor: pod.seats[3].status === "Available" ? 'green' : 'red',
                    color: 'white',
                    minWidth: {xs:'auto',md:'30px'},
                    padding: { xs: '2px', md: '8px' }
                  }}
                >
                  {pod.seats[3].seatId}
                </Button>
              </Box>
            </Box>
          </Box>
        );
      case "horizontal-right":
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box>
              <Box sx={{ display: 'flex' }}>
                <Button
                  variant="text"
                  sx={{
                    backgroundColor: pod.seats[0].status === "Available" ? 'green' : 'red',
                    color: 'white',
                     minWidth: {xs:'auto',md:'30px'},
                    padding: { xs: '2px', md: '8px' }
                  }}
                >
                  {pod.seats[0].seatId}
                </Button>
                <Button
                  variant="text"
                  sx={{
                    backgroundColor: pod.seats[1].status === "Available" ? 'green' : 'red',
                    color: 'white',
                     minWidth: {xs:'auto',md:'30px'},
                    padding: { xs: '2px', md: '8px' }
                  }}
                >
                  {pod.seats[1].seatId}
                </Button>
              </Box>
              <Box sx={{ display: 'flex', mt: {sx:0, md:1} }}>
                <Button
                  variant="text"
                  sx={{
                    backgroundColor: pod.seats[2].status === "Available" ? 'green' : 'red',
                    color: 'white',
                     minWidth: {xs:'auto',md:'30px'},
                    padding: { xs: '2px', md: '8px' }
                  }}
                >
                  {pod.seats[2].seatId}
                </Button>
                <Button
                  variant="text"                  
                  sx={{
                    backgroundColor: pod.seats[3].status === "Available" ? 'green' : 'red',
                    color: 'white',
                     minWidth: {xs:'auto',md:'30px'},
                    padding: { xs: '2px', md: '8px' }
                  }}
                >
                  {pod.seats[3].seatId}
                </Button>
              </Box>
            </Box>
            {/* Pod label on the right */}
            <Typography variant="subtitle2" sx={{ ml: 1 }}>
              Pod-{pod.podId}
            </Typography>
          </Box>
        );
      case "vertical":
        return (
          <Box>
            {/* Pod label on the top */}
            <Typography variant="subtitle2" align="center">
              Pod-{pod.podId}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: {sx:0, md:1} }}>
              <Button
                variant="text"
                sx={{
                  backgroundColor: pod.seats[0].status === "Available" ? 'green' : 'red',
                  color: 'white',
                   minWidth: {xs:'auto',md:'30px'},
                    padding: { xs: '2px', md: '8px' }
                }}
              >
                {pod.seats[0].seatId}
              </Button>
              <Button
                variant="text"
                sx={{
                  backgroundColor: pod.seats[2].status === "Available" ? 'green' : 'red',
                  color: 'white',
                   minWidth: {xs:'auto',md:'30px'},
                    padding: { xs: '2px', md: '8px' }
                }}
              >
                {pod.seats[2].seatId}
              </Button>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: {sx:0, md:1} }}>
              <Button
                variant="text"
                sx={{
                  backgroundColor: pod.seats[1].status === "Available" ? 'green' : 'red',
                  color: 'white',
                   minWidth: {xs:'auto',md:'30px'},
                    padding: { xs: '2px', md: '8px' }
                }}
              >
                {pod.seats[1].seatId}
              </Button>
              <Button
                variant="text"
                sx={{
                  backgroundColor: pod.seats[3].status === "Available" ? 'green' : 'red',
                  color: 'white',
                  minWidth: {xs:'auto',md:'30px'},
                  padding: { xs: '2px', md: '8px' }
                }}
              >
                {pod.seats[3].seatId}
              </Button>
            </Box>
          </Box>
        );
      case "professor-desk":
        return (
          <Box sx={{ width: {xs:'auto',md:'120px'}, height: {xs:'auto',md:'50px'}, backgroundColor: 'lightblue', 
          display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
            <Typography variant="subtitle2" align="center">
              Professor's Desk
            </Typography>
          </Box>
        );
      default:
        return null;
    }
  }; 

  return (
    <div>        
   <Box
      className="dashboard-container"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' }, 
        gap: 2,
        height: { xs: 'auto', md: '600px' } 
      }}
    >
      {session && (
        <Box className="session-container"
        sx={{
          maxWidth: {
            xs: '100%',  
            sm: '100%',  
            md: '300px', 
            lg: '100%', 
            xl: '100%'   
          }
        }}
        >
            <div className="card">
              <p>Location: {session.lab.location}</p>
              <p>Occupancy: {session.occupancy}/{session.lab.capacity}</p>
              <p>Available Computers: {session.availableSeats}</p>
              <p>Start: {new Date(adjustDateToDayOfWeek(session.scheduledStart, session.dayOfWeek)).toLocaleString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</p>
              <p>End: {new Date(adjustDateToDayOfWeek(session.scheduledEnd, session.dayOfWeek)).toLocaleString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</p>
            </div>
        </Box>
      )}
      <Box className='canvas-container'>
        <Box ref={canvasRef} className="canvas" sx={{ width: '100%', height: '100%', position: 'relative' }}>
          {session?.pods.map((pod) => (
            <Box key={pod.podId} className="pod" sx={{ position: 'absolute', left: `${pod.x}px`, top: `${pod.y}px` }}>
              {renderPodLayout(pod)}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
    </div>
  );
};

export default SessionDetails;
